module.exports = __webpack_public_path__ + "fonts/Gilroy-ExtraBold.ce56b25a.woff2";